export class CustomShopInformation {
  url: string;
  returnUrl: string;

  constructor(url: string, returnUrl = '') {
    this.url = url;
    this.returnUrl = returnUrl;
  }
}
